<template>
    <div id="cotact-login-signup" class="user-mh-100">
        <div class="mb-0"></div>
        <section id="filter_options_Section" class="mt-2">
            <slot></slot>
        </section>
        <section id="product-card-section">
            <PageLoading :loading="loading" />
            <template v-if="$page.props.notices.length > 0 && $page.props.notices_show">
                <div class="container">
                    <Notice :notice="notice" :key="notice.name" v-for="notice in $page.props.notices"></Notice>
                </div>
            </template>

            <WinningProductUpdateTrendNotice
                v-if="$page.props.data.productType == 'winning' && $page.props.trending_update_remaining_time"
                :para="$page.props.trending_update_remaining_time"
            />

            <h6 class="mb-3 container" v-if="haveRecord">{{ $page.props.recordInfo }}</h6>
            <div class="mt-5 mb-5" v-if="! haveRecord">
                <ProductRecordNotFound :description="$page.props.recordInfo" />
            </div>
            <div class="all-product-card container">
                <template v-if="haveRecord">
                    <div :class="['Product-card', v.locked ? 'locked-card' : '']" v-for="(v,x) in products.data" :key="v.id">
                        <div class="product-thumnail-wrapper text-center">
                            <div class="locked-status" v-if="v.locked" @click="openDetail(v.detailUrl)">
                                <h3><span class="iconify" data-icon="bi:lock" data-inline="false"></span> Upgrade to Unlock</h3>
                            </div>
                            <template v-if="$page.props.data.productType == 'saved'">
                                <h4 class="seriel-number">{{ v.prno || 'N/A' }}</h4>
                                <Bookmark :product-title="v.title" type="saved" :is-winning="v.is_winning" :id="v.id" :is-bookmark="v.bookmarked" :key="v.id+v.bookmarked"/>
                            </template>
                            <template v-else>
                                <h4 class="seriel-number" v-if="v.prno">{{ v.prno || 'N/A' }}</h4>
                                <h4 class="seriel-number text-dark" style="background: none;" v-else>
                                    <Bookmark v-if="! v.locked" :product-title="v.title" :type="isGuest ? 'guest' : 'list'" :is-winning="v.is_winning" :id="v.id" :is-bookmark="v.bookmarked" :key="v.id+v.bookmarked+x" />
                                </h4>
                                <h4 :class="['trend-status', v.rating_color]" v-if="v.rating">
                                    <span class="iconify me-1" :data-icon="v.rating_icon" data-inline="false"></span>
                                    <span v-html="v.rating"></span>
                                </h4>
                            </template>
                            <img loading="lazy" onerror="this.onerror=null;this.src='/images/default/product.png'" v-if="v.featured_image" :src="v.featured_image" :alt="v.title" @click="openDetail(v.detailUrl)" />
                        </div>
                        <div class="product-desc">
                            <h4 class="mb-3 mt-2 text-capitalize long-and-truncated" data-bs-toggle="tooltip" data-bs-placement="right" :title="v.title">{{ v.title }}</h4>
                            <div class="d-flex mb-2">
                                <h6 class="w-50 text-start">Country: <span>{{ v.country_code.toUpperCase() }}</span></h6>
                                <h6 class="w-50 text-start">Added: {{  v.added_date }}<span></span></h6>
                            </div>
                            <hr class="my-2" />
                            <div class="d-flex flex-wrap" v-if="! v.is_tiktok">
                                <InfoBox class-name="w-50 my-2" style="''" title="CPC" :val="v.cpc" :content="hc.text_cpc" :locked="v.locked"/>
                                <InfoBox class-name="w-50 my-2" style="''" title="Volume" :val="$filters.humanNumber(v.volume)" :content="hc.text_volume" :locked="v.locked"/>
                                <InfoBox class-name="w-50 my-2" style="''" title="Country" :val="v.country_code.toUpperCase()" :content="$filters.initCap(v.country_name)" :locked="v.locked"/>
                                <InfoBox class-name="w-50 my-2" style="''" title="Competition" :val="v.competition" :content="hc.text_competition" :locked="v.locked"/>
                            </div>
                            <a v-if="isGuest && !v.locked" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#authModal" class="theme-btn card-button-view mt-3 round-20 d-block w-100 btn-orange text-center">
                                <span class="iconify" data-icon="carbon:view-filled" data-inline="false"></span>
                                View Details
                            </a>
                            <a v-else :href="v.detailUrl" class="theme-btn card-button-view mt-3 round-20 d-block w-100 btn-orange text-center">
                                <span class="iconify" data-icon="carbon:view-filled" data-inline="false"></span>
                                View Details
                            </a>
                        </div>
                    </div>
                </template>
            </div>
            <div class="container table-responsive mt-4" v-if="haveRecord">
                <pagination class-name="justify-content-center flex-wrap" :links="products.links"></pagination>
            </div>
        </section>
    </div>
</template>

<script>
import PageLoading from "./PageLoading";
import Pagination from "@s/Components/Inertia/IPagination";
import Bookmark from "./Bookmark";
import Notice from "./Notice";
import InfoBox from "./InfoBox";
import ProductRecordNotFound from "./ProductRecordNotFound";
import WinningProductUpdateTrendNotice from "./WinningProductUpdateTrendNotice";
export default {
    name: "Box",
    components: {
        ProductRecordNotFound,
        Bookmark,
        PageLoading,
        'pagination': Pagination, Notice, InfoBox, WinningProductUpdateTrendNotice
    },
    props: {
      products: { required: true },
      loading: { default: false },
      isGuest: { default: false }
    },
    data(){
        return {
            hc: __st.hc,
        }
    },
    computed: {
        haveRecord() {
            return this.products.data.length > 0;
        }
    },
    methods: {
        openDetail(url) {
            location.href = url;
        }
    }
}
</script>
